 import axios from 'axios';
 import createPersistedState from 'vuex-persistedstate';

 const API_URL = 'https://referralsystem.halfhumangames.com/api/referrals';
 
 const state = {
     referrals:  [],
     points: 0,
     user: {},
     email: "",
     pledgeTier:"",
     count: 0,
     tiers: {
        "Tinkerer": 3,
        "Digital Tinkerer": 5,
        "Bug Hunter": 8,
        "Apprentice": 12,
        "Artificer": 12,
        "Elite Artificer": 12,
        "Warsmith": 12,
        "Elite Warsmith": 12,
        "Heroic Warsmith": 12,
        "Legendary Warsmith": 12,
        "Warsmith General": 12,
        "Warsmith Supreme": 12,
     }
 };
 
 const getters = {
     currentUser: user => state.user,
     getCount: count => state.count
 };

 const plugins =  createPersistedState({
    paths: ['state']
 });

 const actions = {
    async fetchUser({commit}, id){
        const response = await axios.get(`${API_URL}/${id}`);

        commit('fetchUser',response.data);
        switch (response.data.pledgeTier) {
            case "Tinkerer":
                commit('countCheck', 3);
                break;
            case "Digital Tinkerer":
                commit('countCheck', 5);
                break;
            case "Bug Hunter":
                commit('countCheck', 8);
                break;
            case "Apprentice":
                commit('countCheck', 12);
                break;
            case "Artificer":
                commit('countCheck', 12);
                break;
            case "Elite Artificer":
                commit('countCheck', 12);
                break;
            case "Warsmith":
                commit('countCheck', 12);
                break;
            case "Elite Warsmith":
                commit('countCheck', 12);
                break;
            case "Heroic Warsmith":
                commit('countCheck', 12);
                break;
            case "Legendary Warsmith":
                commit('countCheck', 12);
                break;
            case "Warsmith General":
                commit('countCheck', 12);
                break;
            case "Warsmith Supreme":
                commit('countCheck', 12);
                break;
            default:
                commit('countCheck', 3);
                break;
            }

        console.log(response)
    },
    async addUser({commit}, newUser){
        const response = await axios.post(API_URL, newUser);
        
        commit('addUser',response.data);
        console.log(response)
    },
    async setTier({commit}, updatedUser){
        const response = await axios.put(`${API_URL}/${updatedUser.id}`, updatedUser); 
        commit('setTier', response.data)
        console.log(response)
    },
    setCount({commit}, points){
        commit('setCount', points);
    },
    countCheck({commit}, count){
        commit('countCheck', count);
    },
    
 };
 
 const mutations = {
    setCount: (state, points) => (state.points = points),
    countCheck: (state, count) => (state.count = count),
    fetchUser: (state, user) => (state.user = user),
    addUser: (state, newUser) => (state.user = newUser),
    setTier: (state, updatedUser) => (state.user = updatedUser),
 };
 
 export default {
     state,
     getters,
     actions,
     mutations,
     plugins
 }


// WEBPACK FOOTER //
// ./src/store/modules/referrals.js